import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const ReadOnlyFolder = () => {
  return (
    <Box
      flexDirection="column"
      alignItems="center"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      gap="s16"
      padding="s24"
      justifyContent="center"
    >
      <Icon.Large icon="alert" color="grey600"></Icon.Large>
      <Text.Normal weight="semibold">{i18n.t('settings.folders.list.read_only.title')}</Text.Normal>
      <Box textAlign="center">
        <Text.Normal>{i18n.t('settings.folders.list.read_only.description')}</Text.Normal>
      </Box>
    </Box>
  )
}

export default ReadOnlyFolder
